import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;

// How often this business used each GL code on completed bank transactions
// (last 180 days). Fetched once per session, shared by every GL picker.
export const getGlUsageStats = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios
      .get(`${API}/bank-feeds/gl-usage-stats`)
      .then((r) => { cache = r.data?.usage || {}; return cache; })
      .catch(() => { inflight = null; return {}; });
  }
  return inflight;
};
